import styles from './AnalysisStep.module.less'
import cls from 'classnames'
import AIcon from '@/components/A/AIcon/AIcon'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MiddleText from '@/components/MiddleText/MiddleText'

interface Props {
  ratio: number
  labels: Array<{ name: string; desc: string; periods: number[] }>
  className?: string
  style?: React.CSSProperties
  notBegin?: boolean
}

function AnalysisStep(props: Props) {
  const { labels } = props
  const [active, setActive] = useState<number>(0)
  const { t } = useTranslation()
  useEffect(() => {
    if (props.notBegin) {
      setActive(-1)
      return
    }
    const _active = labels.findIndex(
      (item) => props.ratio >= item.periods[0] && props.ratio <= item.periods[1]
    )
    setActive(_active === -1 ? labels.length : _active)
  }, [props.ratio, props.labels, props.notBegin])

  return (
    <>
      <div className={cls(styles.analysisStep, props.className)} style={props.style}>
        {labels.map((label, index) => {
          return (
            <span
              key={index}
              className={cls(
                styles.step,
                { [styles.done]: active > index },
                { [styles.active]: active === index }
              )}
            >
              {active > index && (
                <AIcon
                  className={styles.icon}
                  type='icon-fill-global_check'
                  width={20}
                  height={20}
                />
              )}
              {active === index && (
                <AIcon
                  className={styles.icon}
                  type='icon-line-global_loading'
                  width={20}
                  height={20}
                />
              )}
              {active < index && (
                <AIcon
                  className={styles.icon}
                  type='icon-line-global_wait'
                  width={20}
                  height={20}
                />
              )}
              <span className={cls(styles.label, { [styles.loadingShimmer]: active === index })}>
                <MiddleText text={label.name} />
              </span>
              {index < labels.length - 1 && (
                <span
                  className={cls(styles.bar, {
                    [styles.done]: active > index,
                    [styles.active]: active === index,
                  })}
                >
                  <span className={styles.barInner}></span>
                </span>
              )}
            </span>
          )
        })}
      </div>
      {labels[active]
        ? <p className={styles.desc}>{labels[active].desc}</p>
        : props.notBegin
          ? <p className={styles.desc}>{t('dashboard.projectDetailPage.analysisWaitingDesc')}</p>
          : <p className={styles.desc}>{t('dashboard.projectDetailPage.analysisStepDesc')}</p>
      }
    </>
  )
}

export default AnalysisStep
